import { graphql } from "gatsby";
import React from "react";
import Post from "../components/Post";
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import Layout from '../components/layout';
import SEO from '../components/seo';
import ContactForm from '../components/Custom Modules/ContactForm';

/* importing image file */
import BlogLogo from '../images/Blog/Logo.png';

export const AllBlogsQuery = graphql`
  query AllBlogPosts {
    allMarkdownRemark(sort: { fields: frontmatter___date, order: DESC }) {
      edges {
        node {
          frontmatter {
            date(formatString: "DD MMM YYYY")
            title
            description
            author
            path
            imagesrc
          }
        }
      }
    }
  }
`;

const Blog = ({ data }) => (
  <Layout>
    <SEO
      title="Blog"
      description="Blog Page"
      canonical={"https://www.pratiiti.in/blog"}
      url={"https://www.pratiiti.in/blog"}
    />
    <div className="blogLogo">
      <img src={BlogLogo} alt="blog logo"/>
    </div>
    <Grid container className="mainBlogPageContainer">
      <Grid item xs={12} sm={12} md={12}>
        <div className="blogPageHeading">
          {"Latest Blogs"}
        </div>
      </Grid>
    </Grid>
    {
      data.allMarkdownRemark.edges.map((post) => {
        const { title, author, date, description, path, imagesrc } = post.node.frontmatter;

        return (
          <Post
            title={title}
            author={author}
            date={date}
            description={description}
            key={`${date}__${title}`}
            path={path}
            imagesrc={imagesrc}
          />
        );
      })
    }
    <ContactForm/>
  </Layout>
);

export default Blog;
